var BOOLEAN_WITH_ADDITIONAL_OPTIONS_FIELDS, CODE_FIELDS, FIELDS_MAP, FIELDS_WITH_MISSING, FIELDS_WITH_SEMICOLON, REST_FIELDS, YES_NO_TEXT_FIELDS, exportAgreeScore, exportAndSplitBySemicolon, exportBooleanWithAdditionalOptions, exportCodeField, exportFieldWithMissing, exportGuideline, exportGuidelineFields, exportYesNoTextField, get, _ref;

get = require('lodash').get;

_ref = require('lib/services/covid_exporter/utils'), exportAgreeScore = _ref.exportAgreeScore, exportFieldWithMissing = _ref.exportFieldWithMissing, exportGuidelineFields = _ref.exportGuidelineFields, exportCodeField = _ref.exportCodeField, exportYesNoTextField = _ref.exportYesNoTextField, exportAndSplitBySemicolon = _ref.exportAndSplitBySemicolon, exportBooleanWithAdditionalOptions = _ref.exportBooleanWithAdditionalOptions;

YES_NO_TEXT_FIELDS = ['guidelineGroupDetails', 'consumerEngagement', 'peopleWithLivedExperience'];

BOOLEAN_WITH_ADDITIONAL_OPTIONS_FIELDS = ['includeNonEnglishDatabases'];

CODE_FIELDS = ['guidelineInterventions', 'guidelinePopulations'];

FIELDS_WITH_MISSING = ['secondWorldRegionCategory'];

FIELDS_MAP = {
  'fullReference': 'citation',
  'targetAudience': 'users',
  'guidelineInterventions': 'intervention',
  'guidelinePopulations': 'population',
  'secondWorldRegionCategory': 'whoWorldRegion'
};

FIELDS_WITH_SEMICOLON = ['source'];

REST_FIELDS = ['title', 'fullReference', 'publicationDate', 'version', 'organizationType', 'sourceDocumentLink', 'isbn', 'keywords', 'doi', 'pmid', 'declarationOfInterest', 'describedAsRapid', 'describedAsLiving', 'latestLiteratureSearchDate', 'gradingEvidenceMethod', 'focus', 'progress', 'plus', 'progressPlus', 'targetAudience', 'field', 'worldRegion', 'country', 'guidelineNoId', 'whoIrisId', 'authors'];

exportGuideline = function(projectId, guidelineDoc) {
  var agreeScore, booleanWithAdditionalOptionsFields, codesFields, fieldsWithMissing, fieldsWithSemicolon, publicationYear, restFields, yesNoTextFields;
  agreeScore = exportAgreeScore(guidelineDoc);
  publicationYear = guidelineDoc['publicationDate'] ? moment(guidelineDoc['publicationDate']).format('YYYY') : void 0;
  yesNoTextFields = exportGuidelineFields(exportYesNoTextField, YES_NO_TEXT_FIELDS, FIELDS_MAP, guidelineDoc);
  booleanWithAdditionalOptionsFields = exportGuidelineFields(exportBooleanWithAdditionalOptions, BOOLEAN_WITH_ADDITIONAL_OPTIONS_FIELDS, FIELDS_MAP, guidelineDoc);
  codesFields = exportGuidelineFields(exportCodeField, CODE_FIELDS, FIELDS_MAP, guidelineDoc);
  fieldsWithMissing = exportGuidelineFields(exportFieldWithMissing, FIELDS_WITH_MISSING, FIELDS_MAP, guidelineDoc);
  fieldsWithSemicolon = exportGuidelineFields(exportAndSplitBySemicolon, FIELDS_WITH_SEMICOLON, FIELDS_MAP, guidelineDoc);
  restFields = exportGuidelineFields(_.identity, REST_FIELDS, FIELDS_MAP, guidelineDoc);
  return _.extend({
    '@id': projectId,
    agreeScore: agreeScore,
    publicationYear: publicationYear
  }, yesNoTextFields, booleanWithAdditionalOptionsFields, codesFields, fieldsWithMissing, fieldsWithSemicolon, restFields);
};

module.exports = exportGuideline;
